export default __webpack_public_path__ + "static/media/temp-4.1978c225.svg";